import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const ArticleHeadlineToolTip = (props) => (
  <div>
    The title of the break.  Featured on: DB homepage, top of the break and the landing page of sponsored breaks.  Editorial breaks pre-populate headline from the "Break Title" in the General break information section.
    <br/>
    <img src={makeToolTipUrl('article/1.CMS-Article-Headline.png')} width="100%"/>
  </div>
);

export const ArticleHeaderImageToolTip = (props) => (
  <div>
    Lead image that accompanies the article.
    <br/>
    <img src={makeToolTipUrl('article/2.CMS-Article-header-Image.png')} width="100%"/>
  </div>
);

export const ArticleIntroToolTip = (props) => (
  <div>
    Copy to introduce the list.
    <br/>
    <img src={makeToolTipUrl('article/3.CMS-Article-Intro.png')} width="100%"/>
  </div>
);

export const ArticleAllowVotingToolTip = (props) => (
  <div>
    If yes, two buttons will appear at the end of the article to encourage reader interaction by voting.
    <br/>
    <img src={makeToolTipUrl('article/4.CMS-Article-allow-voting.png')} width="100%"/>
  </div>
);

export const ArticleUpvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the upward voting button.
    <br/>
    <img src={makeToolTipUrl('article/5.CMS-Article-upvote-button-text.png')} width="100%"/>
  </div>
);

export const ArticleUpvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the upward voting button.  You can choose from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('article/6.CMS-Article-upvote-button-icon.png')} width="100%"/>
  </div>
);

export const ArticleDownvoteButtonTextToolTip = (props) => (
  <div>
    Text that appears in the downward voting button.
    <br/>
    <img src={makeToolTipUrl('article/7.CMS-Article-downvote-button-text.png')} width="100%"/>
  </div>
);

export const ArticleDownvoteButtonIconToolTip = (props) => (
  <div>
    Icon that appears in the downward voting button.  You can choose from <a href="https://fontawesome.com/v4.7.0/icons/" target="_blank">available icons</a>.
    <br/>
    <img src={makeToolTipUrl('article/8.CMS-Article-downvote-button-icon.png')} width="100%"/>
  </div>
);

export const ArticleAddTrackingToVotingButtonsToolTip = (props) => (
  <div>
    Additional code to track readers who click the voting buttons.
  </div>
);

export const ArticleSubheadToolTip = (props) => (
  <div>
    Copy that introduces this section of the article.
    <br/>
    <img src={makeToolTipUrl('article/9.CMS-Article-subhead.png')} width="100%"/>
  </div>
);

export const ArticleBlockquoteToolTip = (props) => (
  <div>
    Visual callout of a specific quote in the text.
    <br/>
    <img src={makeToolTipUrl('article/10.CMS-Article-blockquote.png')} width="100%"/>
  </div>
);

export const ArticleBodyCopyToolTip = (props) => (
  <div>
    Main copy of the article.
    <br/>
    <img src={makeToolTipUrl('article/11.CMS-Article-body-copy.png')} width="100%"/>
  </div>
);

export const ArticleImageToolTip = (props) => (
  <div>
    The type of image you are adding.  If selecting a static image you have to determine the orientation: horizontal, vertical, or custom.
    <br/>
    <img src={makeToolTipUrl('article/12.CMS-Article-img-style.png')} width="100%"/>
  </div>
);

export const ArticleEmbedToolTip = (props) => (
  <div>
    Paste HTML code to embed a video.
  </div>
);

export const ArticleImageScalingToolTip = (props) => (
  <div>
    Image will upload at 100%, 75% or 65% of the width of the page.  Sponsored content will typically use 75%.
    <br/>
    <img src={makeToolTipUrl('article/13.CMS-Article-scale-img-to-width.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/article-tool-tips.jsx